import classNames from 'classnames';
import type React from 'react';
import { forwardRef } from 'react';
import { CardContent } from './CardContent';
import { CardHeader } from './CardHeader';

export interface CardProps {
  allowHover?: boolean;
  selected?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onMouseEnter?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  children?: React.ReactNode;
  'aria-label'?: string;
  isHovering?: boolean;
  withBackground?: boolean;
  className?: string;
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    {
      allowHover,
      selected,
      onClick,
      onMouseEnter,
      onMouseLeave,
      isHovering,
      children,
      'aria-label': ariaLabel,
      withBackground = true,
      className: extendClassName,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className={classNames(
          'group w-full rounded-md',
          allowHover && 'hover:bg-ds-natural-100',
          selected &&
            'outline outline-1 outline-offset-[-1px] outline-ds-primary-300',
          isHovering ? 'ds-hovered' : 'ds-not-hovered',
          withBackground && 'bg-ds-natural-50',
          extendClassName
        )}
        {...props}
        aria-label={ariaLabel}
      >
        {children}
      </div>
    );
  }
);
Card.displayName = 'Card';

const _Card = Object.assign(Card, {
  Header: CardHeader,
  Content: CardContent,
});

export { _Card as Card };
